// Centralized reduced-shades helpers.
// Responsible for deciding if shades should be reduced and applying that choice to a container.
(function () {
  if (window.reduceShades) return;

  const normalize = (val) => (val || '').toString().trim().toLowerCase();

  async function inferSource(providedSource) {
    const normalized = normalize(providedSource);
    if (normalized) return normalized;

    if (typeof window.getProductAddedFromSource === 'function') {
      try {
        return normalize(await window.getProductAddedFromSource());
      } catch (e) {
        return '';
      }
    }

    return '';
  }

  async function shouldReduceShades({ target, source, override } = {}) {
    if (typeof override === 'boolean') return override;

    const targetSet = normalize(target);
    const src = await inferSource(source);

    if (!targetSet) return false;

    if (targetSet === 'tarte gwp') return src === 'tarte_gwp';
    if (targetSet === 'pdp and checkout special') return true;
    if (targetSet === 'checkout special') return src === 'recommended' || src === 'checkout special';

    if (targetSet === 'pdp') {
      // When no explicit source is known, default to reducing on PDP to mirror current behavior.
      return src ? src === 'pdp' : true;
    }

    return false;
  }

  function applyReducedShades(container, shouldReduce, { removeNonReduced = false } = {}) {
    if (!container) return;
    const targets = container.querySelectorAll('[data-include-reduced="false"]');

    targets.forEach((node) => {
      if (removeNonReduced) {
        if (shouldReduce) node.remove();
      } else {
        node.style.display = shouldReduce ? 'none' : '';
      }
    });
  }

  async function decideAndApply(container, options = {}) {
    const shouldReduce = await shouldReduceShades(options);
    applyReducedShades(container, shouldReduce, options);
    return shouldReduce;
  }

  window.reduceShades = {
    shouldReduceShades,
    applyReducedShades,
    decideAndApply,
  };

  // Backwards compatibility for existing callers expecting shouldRemoveSlides(target, source?)
  window.shouldRemoveSlides = async (target, source) => shouldReduceShades({ target, source });
})();
